/*
 * サブシステム名：設定その他
 * 機能名：データ取込
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2PRMT0800.js'
import filter from '@/rahmen/utils/filters'

import DdDropDown from '@/components/DdDropDown'
import DdDigitakoRirekiSearchButton from '@/components/DdDigitakoRirekiSearchButton'
import DdFileInput from '@/components/DdFileInput'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import date from '@/ddv2.library/date'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'

const DdDateRangeBox = () => import('@/components/DdDateRangeBox')

export default {
  name: 'DataImportList',
  mixins: [flowMixin],
  data: () => ({
    isConditionHide: false,
    itemsPerPage: 100,
    page: 1,
    conditions: {
      DigitakoId: null,
      UploadFileName: '',
      UploadFileData: '',
      UploadSagyoMeisaiName: '',
      UploadSagyoMeisaiData: ''
    },
    apiIntegrationFlg: false,
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,
    digitakoTorikomiLastInfo: {},
    recordCount: 0,
    successCount: 0,
    errorCount: 0,
    dispSokoMeisai: false,
    modeKengen: 0
  }),
  components: {
    VTour,
    DdCustomButton,
    DdTransparentButton,
    DdDateRangeBox,
    DdDropDown,
    DdDigitakoRirekiSearchButton,
    DdFileInput,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      makerList: 'DDMasters/mstDigitakoJoho',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredMaker () {
      // /* eslint no-debugger: "warn" */
      // debugger
      var defArray = [{ value: null, text: '選択してください' }]
      const makerList = this.makerList.filter(function (elem) {
        return elem
      }).map(function (elem) {
        elem.value = elem.digitakoTeigiId
        elem.text = elem.digitakoName
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.digitakoTeigiId > elem2.digitakoTeigiId) { return 1 }
        if (elem1.digitakoTeigiId === elem2.digitakoTeigiId) { return 0 }
        return -1
      })
      return defArray.concat(makerList)
    },
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.importStartDisp = elem.importStart ? dayjs(elem.importStart).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.importEndDisp = elem.importEnd ? dayjs(elem.importEnd).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.jomuinDisp = elem.jomuinNm === null ? elem.jomuinCd : elem.jomuinNm
        elem.dokoshaDisp = elem.dojoshaNm === null ? elem.dojoshaCd : elem.dojoshaNm
        elem.unkoYmdDisp = elem.unkoYmd ? dayjs(elem.unkoYmd).format('YYYY/MM/DD') : ''
        elem.unkoStartYmdDisp = elem.unkoStartYmd ? dayjs(elem.unkoStartYmd).format('YYYY/MM/DD') : ''
        elem.unkoEndYmdDisp = elem.unkoEndYmd ? dayjs(elem.unkoEndYmd).format('YYYY/MM/DD') : ''
        return elem
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstdigitakojoho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'csvRowNo', align: 'center' },
              { text: '運行ID', value: 'unkoJissekiNo', align: 'center' },
              { text: '乗務員', value: 'jomuinDisp' },
              { text: '同乗者', value: 'dokoshaDisp' },
              { text: '車両', value: 'sharyoNo' },
              { text: '車種', value: 'sharyoSbt' },
              { text: '運行年月日', value: 'unkoYmdDisp' },
              { text: '運行開始', value: 'unkoStartYmdDisp' },
              { text: '時刻', value: 'unkoStartHms' },
              { text: '運行終了', value: 'unkoEndYmdDisp' },
              { text: '時刻', value: 'unkoEndHms' },
              { text: 'エラー情報', value: 'errorMsg' },
              { text: 'デジタコ運行ID', value: 'digitakoUnkoId' },
              { text: '枝番', value: 'digitakoUnkoIdEdaNo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            self.getLastDigitakoTorikomiRirekiInfo()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onTorikomiButtonClick: function (e) {
      console.log('cklick')
      this.clearInvalidMessage(this.$refs)
      let errorCount = 0
      if ((['', null, undefined]).includes(this.conditions.DigitakoId)) {
        this.$refs.maker[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if (this.apiIntegrationFlg) {
        if (this.conditions.torikomiTargetYmdFromString && this.conditions.torikomiTargetYmdToString) {
          const msg1 = validators.compareDate(this.conditions.torikomiTargetYmdFromString, this.conditions.torikomiTargetYmdToString)
          if (msg1 !== undefined) {
            this.$refs.torikomiTargetYmdFromToString[this.Ctrls.SET_INVALID_METHOD](msg1)
            this.setInvalidSummaryMessage('COME0014')
            errorCount++
          }
        } else {
          this.$refs.torikomiTargetYmdFromToString[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          errorCount++
        }
      } else {
        if ((['', null, undefined]).includes(this.conditions.UploadFileData) && (['', null, undefined]).includes(this.conditions.UploadSagyoMeisaiData)) {
          this.$refs.unkoJissekiFile[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0117', ['運行実績または走行明細ファイル']))
          this.$refs.sokoMeisaiFile[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0117', ['運行実績または走行明細ファイル']))
          errorCount++
        }
      }
      if (errorCount > 0) { return }

      this.Effects.loadStart()
      console.log('Torikomi start', e)
      this.HttpClient.post('/api/v1/D2PRMD0800/Upload', this.conditions)
        .then((data) => {
          if (data.isValid) {
            console.log('retdata', data)
            modals.showToastMessage(data.summaryMessage.messageCd, null, 400, null, 'info')
            this.rows = data.payload.result.resultList ? data.payload.result.resultList : this.rows
            this.recordCount = data.payload.result.recordCount
            this.successCount = data.payload.result.successCount
            this.errorCount = data.payload.result.errorCount
            this.getLastDigitakoTorikomiRirekiInfo()
            this.Effects.loadComplete()
            // this.transition(0, { id: data.payload, edit: 1 })
          } else {
            modals.showToast(data.summaryMessage, null, 500, null, 'error')
            this.Effects.loadComplete()
          }
        }).catch((e) => {
          console.log('error', e)
          modals.showToast(e.message, null, 500, null, 'error')
          // this.setSummaryMessage(e.message)
          this.Effects.loadComplete()
        })
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      // console.log(e)
      // this.Effects.loadStart()
      // this.transition(0, { id: e.id, edit: 0 })
    },
    searchValidate: function () {
      return true
    },
    storeUnkoJissekiFileInfo: function (unkoJissekiFile) {
      console.log('file selected', unkoJissekiFile)
      if (unkoJissekiFile === undefined || unkoJissekiFile === null) {
        this.conditions.UploadFileName = ''
        this.conditions.UploadFileData = ''
        return
      }
      this.Effects.loadStart()
      this.conditions.UploadFileName = unkoJissekiFile.name

      const fr = new FileReader()
      fr.readAsDataURL(unkoJissekiFile)
      fr.addEventListener('load', () => {
        this.conditions.UploadFileData = fr.result
      })
      this.Effects.loadComplete()
      console.log('file selected e')
    },
    storeSokoMeisaiFileInfo: function (sokoMeisaiFile) {
      console.log('file selected', sokoMeisaiFile)
      if (sokoMeisaiFile === undefined || sokoMeisaiFile === null) {
        this.conditions.UploadSagyoMeisaiName = ''
        this.conditions.UploadSagyoMeisaiData = ''
        return
      }
      this.Effects.loadStart()
      this.conditions.UploadSagyoMeisaiName = sokoMeisaiFile.name

      const fr = new FileReader()
      fr.readAsDataURL(sokoMeisaiFile)
      fr.addEventListener('load', () => {
        this.conditions.UploadSagyoMeisaiData = fr.result
      })
      this.Effects.loadComplete()
      console.log('file selected e')
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    },
    inputDigitakoInfo: function () {
      const self = this
      const target = self.makerList.find(function (elem) {
        return elem.digitakoTeigiId === self.conditions.DigitakoId
      })
      if (!target) {
        self.apiIntegrationFlg = false
        return
      }
      self.dispSokoMeisai = Boolean(target.sokoMeisaiFormatCd)
      self.apiIntegrationFlg = target.apiIntegrationFlg
    },
    getLastDigitakoTorikomiRirekiInfo: function () {
      const rirekiConditions = {
        getRecordsCount: 1
      }
      this.HttpClient.post('/api/v1/D2prmd0800/GetUploadHistory', rirekiConditions)
        .then((data) => {
          if (data.payload.length > 0) {
            const p = data.payload[0]
            const getLastDigitakoTorikomiLastInfo = {
              operationStartDatetimeDisp: p.operationStartDatetime ? filter.dateYmdHmsFormatter(p.operationStartDatetime) : '',
              jininNmSei: p.jininNmSei,
              unkoFromTo: p.minUnkoStart && p.maxUnkoEnd ? filter.dateFormatter(p.minUnkoStart) + ' ~ ' + filter.dateFormatter(p.maxUnkoEnd) : p.minUnkoStart ? filter.dateFormatter(p.minUnkoStart) : p.maxUnkoEnd ? filter.dateFormatter(p.maxUnkoEnd) : '',
              digitakoUnkoIdFromTo: p.minDigitakoUnkoId && p.maxDigitakoUnkoId
                ? this.truncate(p.minDigitakoUnkoId, 12) + ' ~ ' + this.truncate(p.maxDigitakoUnkoId, 12)
                : p.minDigitakoUnkoId
                  ? this.truncate(p.minDigitakoUnkoId, 12)
                  : p.maxDigitakoUnkoId
                    ? this.truncate(p.maxDigitakoUnkoId, 12)
                    : ''
            }
            this.digitakoTorikomiLastInfo = getLastDigitakoTorikomiLastInfo
          }
        })
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        DigitakoId: '',
        UploadFileName: '',
        UploadFileData: '',
        UploadSagyoMeisaiName: '',
        UploadSagyoMeisaiData: '',
        torikomiTargetYmdFromString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        torikomiTargetYmdToString: date.getLastDate(d.getFullYear(), d.getMonth() + 1)
      }
      this.conditions = initConditions
      this.apiIntegrationFlg = false
      this.searchText = ''
      this.rows = []
    },
    // 補助関数
    truncate: function (str, len) {
      return str.length > len ? str.substring(0, len) + '…' : str
    }
  }
}
